module.exports = function numtype(num, def) {
	return typeof num === 'number'
		? num 
		: (typeof def === 'number' ? def : 0)
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/as-number/index.js
// module id = 72
// module chunks = 0 1